import FieldBase from './FieldBase'

export default class extends FieldBase {
  constructor({ simple = false, ...args }) {
    super(args)
    const component = this.getComponentWithVModel('wysiwyg-input')
    component.attrs['simple'] = simple
    this.children = [component]
  }
}
